<template>
  <section class="custom_page funnel_page" style="">
    <card type="secondary" style="" v-if="is_notify_load" shadow
          header-classes="bg-white pb-5"
          body-classes=""
          class="border-0 funnel_card">
      <div class="col-lg-12">
        <h2 class="m-4"  >Все уведомления</h2>

      </div>
      <div class="col-12">
        <sui-form-field>
          <sui-checkbox toggle @change="changeNotifyType" v-model="notify.show_only_unread"
                        label="Показывать только не прочитанные"/>
        </sui-form-field>
      </div>
      <div class="col-12">
        <p><button class="btn side4" type="button" @click="markerAllNotifyRead">Пометить все прочитанным</button></p>

      </div>
    <ul class="nav mt-4">
      <li class="nav-item">
        <a class="nav-link " :class="{ 'active_btn':open_tab=='all' }" @click="openType('all')">Все<span class="badge badge-light">{{ notify_counts.total}}</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{ 'active_btn':open_tab=='projects' }"  @click="openType('projects')">Проекты и задачи<span class="badge badge-light">{{ notify_counts.projects}}</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{ 'active_btn':open_tab=='freelance' }" @click="openType('freelance')">Фриланс<span class="badge badge-light">{{ notify_counts.freelance}}</span></a>
      </li>

      <li class="nav-item">
        <a class="nav-link" :class="{ 'active_btn':open_tab=='invoices' }" @click="openType('invoices')">Счета<span class="badge badge-light">{{ notify_counts.invoices}}</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{ 'active_btn':open_tab=='comments' }" @click="openType('comments')">Комментарии<span class="badge badge-light">{{ notify_counts.comments}}</span></a>
      </li>

    </ul>

      <div class="row mt-4">

        <div class="card col-lg-12 mt-4" v-if="((notify.show_only_unread==true && notify_object.isread==0) || (notify.show_only_unread==false) && (notify_object.json.type==open_tab || open_tab=='all'))"
             v-for="(notify_object,notify_index) in notifys" :key="notify_object.last_id">
          <p>{{ notify_object.who.name}} {{ notify_object.json.title}}</p>
          <p><i class="ni ni-calendar-grid-58"></i> {{ notify_object.created_at}}</p>
          <div v-for="(button,button_index) in notify_object.json.buttons" :key="button_index">
            <a href="javascript:void;" @click="clickNotify(button,notify_object,notify_index)">{{ button.title }}</a>&nbsp;&nbsp;
            &nbsp;
          </div>

        </div>
      </div>
    </card>
  </section>
</template>

<script>
import Api from "../../models/Api";

export default {
  name: "Notify",
  data() {
    return {
      "open_tab": "all",
      is_notify_load: false,
      "notify_counts": {
        "total":0,
        "projects": 0,
        "freelance": 0,
        "comments": 0,
        "invoices": 0,
      },
      "notifys": null,
      "notify": {
        "show_only_unread": true,
      },

    }
  },
  mounted: function () {
    var app=this;
    app.is_notify_load = false;
    app.notify_counts.comments = 0;
    app.notify_counts.freelance = 0;
    app.notify_counts.projects = 0;
    app.notify_counts.invoices = 0;
    app.notify_counts.total = 0;



    Api.loadNotify(app.notify, function (notifys) {

      var projects_count = 0;
      var freelance_count = 0;
      var invoices_count = 0;
      var comments_count = 0;
      var  total_count=0;
      if (notifys.length) {
        notifys.forEach(function callback(currentValue, index, array) {
          if (((currentValue.isread == 0 && app.notify.show_only_unread==true) || (app.notify.show_only_unread==false))  && currentValue.json.type == "projects") {
            projects_count++;
            total_count++;
          }
          if (((currentValue.isread == 0 && app.notify.show_only_unread==true) || (app.notify.show_only_unread==false)) && currentValue.json.type == "freelance") {
            freelance_count++;
            total_count++;
          }
          if (((currentValue.isread == 0 && app.notify.show_only_unread==true) || (app.notify.show_only_unread==false)) && (currentValue.json.type == "comments" || currentValue.json.type == "blogpost_new_comment")) {
            comments_count++;
            total_count++;
          }
          if (((currentValue.isread == 0 && app.notify.show_only_unread==true) || (app.notify.show_only_unread==false)) && currentValue.json.type == "invoices") {
            invoices_count++;
            total_count++;
          }
        })
        app.notify_counts.comments = comments_count;
        app.notify_counts.freelance = freelance_count;
        app.notify_counts.projects = projects_count;
        app.notify_counts.invoices = invoices_count;
        app.notify_counts.total= total_count;
      }



      app.notifys = notifys;
      app.is_notify_load = true;

    });
  },

  methods: {
    openType(type){
      var app=this;
      app.open_tab=type;

    },
    clickNotify(button, notify, notify_index) {
      console.log('click notify btn');
      console.log(button);
      console.log(notify);
      var app = this;
      Api.setReadNotify(notify.last_id, function () {

        if (app.notify.show_only_unread == true) {
          app.loadNotify();
        }
        if (button.type == "load_invoice") {
          app.$router.push({"name": "invoice", "params": {"id": button.params.invoice_id, "rand": Math.random()}});
          // this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
          // vm.$forceUpdate();
        }
        if (button.type == "load_project") {
          app.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
          // this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
          // vm.$forceUpdate();

        }
        if(button.type=="load_post"){
          app.$router.push({"name": "post", "params": {"id": button.params.id, 'alias':button.params.alias,"rand": Math.random()}});
        }
        if (button.type == "remove_notify") {
          Api.setRemoveNotify(notify.last_id, function () {
            app.loadNotify();
          });
        }
      });

    },
    changeNotifyType() {
      this.loadNotify();
    },
    markerAllNotifyRead() {
      var app = this;
      Api.setReadAllNotify(function () {


        app.notifys = [];
        app.is_notify_load = false;
        app.notify_counts.total = 0;
        app.notify_counts.comments = 0;
        app.notify_counts.freelance = 0;
        app.notify_counts.projects = 0;
        app.notify_counts.invoices = 0;
        app.loadNotify();
      });
    },
    loadNotify() {
      var app = this;
      app.is_notify_load = false;
      app.notify_counts.comments = 0;
      app.notify_counts.freelance = 0;
      app.notify_counts.projects = 0;
      app.notify_counts.invoices = 0;
      app.notify_counts.total = 0;
      Api.loadNotify(app.notify, function (notifys) {

        var projects_count = 0;
        var freelance_count = 0;
        var invoices_count = 0;
        var comments_count = 0;
        var total_count=0;
        if (notifys.length) {
          notifys.forEach(function callback(currentValue, index, array) {
            if (((currentValue.isread == 0 && app.notify.show_only_unread==true) || (app.notify.show_only_unread==false))  && currentValue.json.type == "projects") {
              projects_count++;
              total_count++;
            }
            if (((currentValue.isread == 0 && app.notify.show_only_unread==true) || (app.notify.show_only_unread==false)) && currentValue.json.type == "freelance") {
              freelance_count++;
              total_count++;
            }
            if (((currentValue.isread == 0 && app.notify.show_only_unread==true) || (app.notify.show_only_unread==false)) && (currentValue.json.type == "comments" || currentValue.json.type == "blogpost_new_comment")) {
              comments_count++;
              total_count++;
            }
            if (((currentValue.isread == 0 && app.notify.show_only_unread==true) || (app.notify.show_only_unread==false)) && currentValue.json.type == "invoices") {
              invoices_count++;
              total_count++;
            }
          })
          app.notify_counts.comments = comments_count;
          app.notify_counts.freelance = freelance_count;
          app.notify_counts.projects = projects_count;
          app.notify_counts.invoices = invoices_count;
          app.notify_counts.total=total_count;
        }


        app.notifys = notifys;
        app.is_notify_load = true;

      });
    },
  }
}
</script>

<style scoped>

</style>